export const NEW_INBOX_ID = 'new_inbox'
